import { MD_CASES_LIST_FILTER_SEARCH_PARAM_SHAPE } from 'pages/cases/md/mdCasesListSearchContract'
import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

export const SEARCH_PARAM_CASE_ID = 'caseId'
export const CASE_LIST_VIEWS = ['active', 'shelved', 'archived', 'all'] as const

export type CaseListView = (typeof CASE_LIST_VIEWS)[number]

const showArchivedSearchParam = z
  .union([
    z.boolean(),
    z.enum(['true', 'false']).transform((value) => value === 'true'),
  ])
  .optional()

const caseViewSearchParam = z.enum(CASE_LIST_VIEWS).optional()

export const caseListSearchParams = z
  .object({
    [SEARCH_PARAM_SITE_ID]: z.string(),
    ...MD_CASES_LIST_FILTER_SEARCH_PARAM_SHAPE,
    showArchived: showArchivedSearchParam,
    caseView: caseViewSearchParam,
  })
  .transform(({ caseView, showArchived, ...rest }) => ({
    ...rest,
    showArchived: showArchived ?? false,
    caseView: caseView ?? (showArchived ? 'all' : 'active'),
  }))

export type CaseListSearch = z.infer<typeof caseListSearchParams>

export const caseDetailsSearchParams = z.object({
  [SEARCH_PARAM_SITE_ID]: z.string(),
  [SEARCH_PARAM_CASE_ID]: z.string().catch(''),
})
